import { SearchRouterQueryKey } from '../../types';

export type LocationQuery = {
  [SearchRouterQueryKey.Country]?: string;
  [SearchRouterQueryKey.City]?: string | number;
  [SearchRouterQueryKey.CitySubDivision]?: string;
  [SearchRouterQueryKey.LocationId]?: string;
  [SearchRouterQueryKey.Location]?: string;
  [SearchRouterQueryKey.LowestLocationlevel]?: string;
};

export const KEYS = {
  ENTER: 'Enter',
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
};
